import {
    SET_PARTENAIRES_ACAD_LOADING,
    SET_PARTENAIRES_ACAD_ERROR,

    FETCH_PARTENAIRES_ACAD_SUCCESS,
    FETCH_PARTENAIRES_ACAD_FAIL,

    CREATE_PARTENAIRE_ACAD_FAIL,
    UPDATE_PARTENAIRE_ACAD_FAIL,

    DELETE_PARTENAIRE_ACAD_SUCCESS,
    DELETE_PARTENAIRE_ACAD_FAIL,
} from "../actions/partenairesAcademiquesActions";

const initialState = {
    loading: false,
    error: null,
    partenairesAcademiques: [],
};

export default function partenairesAcademiquesReducer(state = initialState, action) {
    switch (action.type) {

        // ===== LOADING =====
        case SET_PARTENAIRES_ACAD_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        // ===== ERROR GLOBAL =====
        case SET_PARTENAIRES_ACAD_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        // ===== FETCH =====
        case FETCH_PARTENAIRES_ACAD_SUCCESS:
            return {
                ...state,
                partenairesAcademiques: action.payload || [],
                error: null,
            };

        case FETCH_PARTENAIRES_ACAD_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        // ===== CREATE / UPDATE FAIL =====
        case CREATE_PARTENAIRE_ACAD_FAIL:
        case UPDATE_PARTENAIRE_ACAD_FAIL:
        case DELETE_PARTENAIRE_ACAD_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        // ===== DELETE SUCCESS =====
        case DELETE_PARTENAIRE_ACAD_SUCCESS:
            return {
                ...state,
                partenairesAcademiques: state.partenairesAcademiques.filter(
                    (p) => p.id !== action.payload
                ),
                error: null,
            };

        default:
            return state;
    }
}
